/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { TableCell } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import SortingIcon from '../../../common/SortingIcon';
import useStyles from '../FOTableHeadStyle';
import FOHeadCellToolTip from './FoHeadTooltip';

const FOHeadCell = (props) => {
  const classes = useStyles();
  const { data, onClickCell, getSortOrderForColumn } = props;
  const { t } = useTranslation();
  const currentURL = window?.location?.href;
  const _data = _.first(data?.conditions?.filter(item => currentURL?.includes(item?.case?.url))) || data;

  return (
    <TableCell
      key={_data.sortId}
      className={clsx(classes.tableHeadCell, classes.unwrappedTableCell)}
      onClick={_data.sortId && onClickCell(_data.sortId)}
    >
      <div>
        <span>{t(_data.label)}</span>
        {_data.sortId && <SortingIcon sortOrder={getSortOrderForColumn(_data.sortId)} />}
        {_data?.tooltipContent && (
          <FOHeadCellToolTip tooltipContent={_data?.tooltipContent} tooltipAria={t(_data.label)} />
        )}
      </div>
    </TableCell>
  );
};

export default FOHeadCell;
